import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class GroupServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getSelect(params = {}) {
    return this.pure_http.get(`/pbx/client/select/groups`, { params: params }).then(res => {
      return res.filter(i => i.contact_methods_count);
    });
  }

  addContactMethod(group_id, contact_method_id) {
    return this.pure_http.post(`/pbx/groups/${group_id}/contacts`, { contact_method_id });
  }

  removeContactMethod(group_id, contact_method_id) {
    return this.pure_http.delete(`/pbx/groups/${group_id}/contacts/${contact_method_id}`);
  }
}

export const GroupService = new GroupServiceClass({
  api_version: 2,
  resource: 'pbx/groups'
});
